
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'SpaceBlock',
  computed: {
    getClasses: function () {
      const list = [];

      if (this.values?.space === 'uk-margin-small') {
        list.push('small');
      }
      if (this.values?.space === 'uk-margin-medium') {
        list.push('medium');
      }
      if (this.values?.space === 'uk-margin-large') {
        list.push('large');
      }

      return list.join(' ');
    },
  },
});
